<generic-card
    [title]="title"
    [descriptionTitle]="descriptionTitle"
    [descriptionContent]="descriptionContent"
    [error]="error"
    [isLoading]="isLoading"
    [ngClass]="cardClass">
    @if (isLoading) {
        <ed-skeleton-list></ed-skeleton-list>
    } @else {
        <ed-table
            *ngIf="dataSource?.data?.length"
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns">
        </ed-table>
    }
</generic-card>
